export default {"src":"/_next/static/image/public/images/flags/flag_269.28f2719107b5b25a0b5abb352b32ef7f.svg","height":16,"width":24};